import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVerifiedComponent } from "./med-icon-verified.component";

@NgModule({
  declarations: [
    MedIconVerifiedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVerifiedComponent,
  ],
})
export class MedIconVerifiedModule { }
